<template>
  <v-expand-transition class='w-expandable-y'>
    <div
      v-show='value'
      class='w-expandable-y__content-wrapper'
    >
      <slot />
    </div>
  </v-expand-transition>
</template>

<script>
import { useTimerManager } from '@/composables/timer-manager';

export default {
  name: 'WorkExpandableY',
  props: {
    value: { type: Boolean, required: true },
    withoutTransitionEvents: { type: Boolean, default: false },
  },
  setup() {
    const { registerTimeout } = useTimerManager();
    return {
      registerTimeout,
    };
  },
  watch: {
    value() {
      if (this.withoutTransitionEvents === true) { return }

      this.$emit('transisiton:started');
      this.registerTimeout(() => this.$emit('transisiton:finished'), 300);
    }
  }
};
</script>
